export const formatDate = (date) => {
  const d = new Date(date)
  let month = '' + (d.getMonth() + 1)
  let day = '' + d.getDate()
  const year = d.getFullYear()

  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day

  return [month, day, year].join('-')
}

export const formatDateYMD = (date) => {
  const d = new Date(date)
  let month = '' + (d.getMonth() + 1)
  let day = '' + d.getDate()
  const year = d.getFullYear()

  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day

  return [year, month, day].join('-')
}

export const formatDateToISO = (date) => {
  if (!date) {
    return date
  }

  return date.toISOString()
}

export const getDateDaysAgo = (days) => {
  const now = new Date()
  now.setDate(now.getDate() - days)
  return now
}

export const getDateTime = (dateTime) => {
  const d = new Date(dateTime)
  let month = '' + (d.getMonth() + 1)
  let day = '' + d.getDate()
  const year = d.getFullYear()
  let hours = d.getHours()
  let minutes = d.getMinutes()
  const ampm = hours >= 12 ? 'PM' : 'AM'
  hours = hours % 12
  hours = hours || 12 // the hour '0' should be '12'
  minutes = minutes < 10 ? '0' + minutes : minutes
  const time = hours + ':' + minutes + ' ' + ampm

  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day

  const formatedDateTime = `${month}-${day}-${year} ${time}`

  return formatedDateTime
}

export const toUTCDateString = (date) => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}T00:00:00Z`;
}

export const convertToEasternISO = (date, hours = 0, minutes = 0, seconds = 0, milliseconds = 0) => {
  if (!date) return null;

  // Create the date with specified time
  const targetDate = new Date(date)
  targetDate.setHours(hours, minutes, seconds, milliseconds)

  // Use toLocaleString with Eastern timezone to get the correct local time
  const easternDateString = targetDate.toLocaleString('sv-SE', {
    timeZone: 'America/New_York'
  }).replace(' ', 'T')

  // Determine if it's EST or EDT for this date
  const january = new Date(targetDate.getFullYear(), 0, 1)
  const july = new Date(targetDate.getFullYear(), 6, 1)

  const januaryOffset = january.toLocaleString('en-US', {
    timeZone: 'America/New_York',
    timeZoneName: 'short'
  }).includes('EST')

  const julyOffset = july.toLocaleString('en-US', {
    timeZone: 'America/New_York',
    timeZoneName: 'short'
  }).includes('EDT')

  // Check if current date is in DST
  const currentOffset = targetDate.toLocaleString('en-US', {
    timeZone: 'America/New_York',
    timeZoneName: 'short'
  }).includes('EDT')

  const offset = currentOffset ? '-04:00' : '-05:00'

  return `${easternDateString}${offset}`
}

// Helper function to convert MM-DD-YYYY format to Date object


export const convertToEasternFormat= (date) => {
  if (!date) return null;

  // Create the date with specified time
  const targetDate = new Date(date);

  // Get the date in Eastern timezone
  const easternDate = new Date(targetDate.toLocaleString('en-US', {
    timeZone: 'America/New_York'
  }));

  // Extract day, month, year, hours, minutes
  const day = easternDate.getDate().toString().padStart(2, '0');
  const month = (easternDate.getMonth() + 1).toString().padStart(2, '0');
  const year = easternDate.getFullYear();
  const hour = easternDate.getHours().toString().padStart(2, '0');
  const minute = easternDate.getMinutes().toString().padStart(2, '0');

  return `${month}/${day}/${year} ${hour}:${minute}`;
};

export const parseFormattedDate = (dateString) => {
  if (!dateString) return null;

  // Handle MM-DD-YYYY format
  const parts = dateString.split('-');
  if (parts.length === 3) {
    const month = parseInt(parts[0], 10) - 1; // Month is 0-indexed
    const day = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);
    return new Date(year, month, day);
  }

  // Fallback to regular Date parsing
  return new Date(dateString);
}

// Convert date range to Eastern timezone for API
export const convertDateRangeToEastern = (startDate, endDate) => {
  const start = parseFormattedDate(startDate);
  const end = parseFormattedDate(endDate);

  return {
    startDate: start ? convertToEasternISO(start, 0, 0, 0, 0) : null, // Start of day
    endDate: end ? convertToEasternISO(end, 23, 59, 59, 999) : null   // End of day
  };
}
